// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Router e navigazione ======
let _lastView = null;

// Render di una vista lazy: attende l'iniezione del fragment e POI renderizza.
// Necessario perché la CSP di produzione blocca gli <script> inline dei fragment.
function lazyRender(id, fn) {
  if (typeof ensureViewLoaded === 'function') ensureViewLoaded(id).then(fn).catch(fn);
  else fn();
}
async function setView(view) {
  // Se sto cambiando vista e c'e' qualcosa di non salvato, chiedo prima
  if (typeof confirmIfDirty === 'function') {
    const ok = await confirmIfDirty();
    if (!ok) return;
  }
  if (!canSee(view)) {
    toast('Sezione riservata agli amministratori');
    view = 'dashboard';
  }
  const prev = _lastView;
  _lastView = view;
  $$('.nav-item').forEach((n) => n.classList.toggle('active', n.dataset.view === view));
  $$('.view').forEach((v) => v.classList.toggle('hidden', v.id !== 'view-' + view));
  // S1: carica la vista se è in modalità lazy
  if (typeof ensureViewLoaded === 'function') {
    ensureViewLoaded(view).catch(() => {
      /* silent */
    });
  }
  // G5: skeleton globale (auto-rimosso al primo render reale o dopo 4s)
  if (typeof showViewSkeleton === 'function') {
    showViewSkeleton(view, { maxMs: 1200 });
    setTimeout(() => {
      if (typeof hideViewSkeleton === 'function') hideViewSkeleton(view);
    }, 1200);
  }
  // S3: emetti evento sul bus per chi vuole ascoltare invece di patchare setView
  globalThis.bus?.emit('view:changed', { view, prev });
  const titles = {
    dashboard: ['Dashboard', 'Panoramica generale'],
    controllo: [
      'Controllo area',
      'Vista direzionale: carico del team, copertura accessi, rinnovi e andamento'
    ],
    todos: ['Le mie attività', 'To-do personale: cosa devo fare oggi e questa settimana'],
    clienti: ['Clienti', 'Anagrafica clienti in gestione Ma.Se.'],
    risorse: ['Risorse', 'Team Managed Services'],
    'risorsa-detail': [
      'Detail risorsa',
      'Clienti, accessi, ruoli e note per la risorsa selezionata'
    ],
    pm: ['Riferimenti interni', 'CPL, PM1, PM2 per cliente'],
    azioni: ['Azioni aperte', 'Utenze da richiedere o gestire'],
    scadenze: ['Scadenze', 'Contratti, certificati, rinnovi'],
    storico: ['Storico', 'Audit log delle modifiche'],
    ruoli: ['Catalogo ruoli', 'Ruoli predefiniti, custom e cruscotto di utilizzo'],
    sicurezza: ['Sicurezza', 'Gestione utenti e backup dati'],
    impostazioni: ['Impostazioni', 'Profilo e legenda stati']
  };
  let [t, s] = titles[view] || ['', ''];
  // La home cambia faccia in base al ruolo: l'admin vede il riepilogo della
  // giornata, il collega vede "Le mie cose" (i suoi clienti/attività/accessi).
  if (view === 'dashboard') {
    const gu = typeof getCurrentUser === 'function' ? getCurrentUser() : null;
    const first = (gu?.name || '').split(' ')[0] || '';
    const hh = new Date().getHours();
    const part = hh < 12 ? 'Buongiorno' : hh < 18 ? 'Buon pomeriggio' : 'Buonasera';
    const hello = `${part}${first ? ', ' + first : ''}`;
    if (typeof isUtente === 'function' && isUtente()) {
      t = 'Le mie cose';
      s = `${hello} — i tuoi clienti, le tue attività e i tuoi accessi`;
    } else {
      t = 'Riepilogo di oggi';
      s = `${hello} — cosa richiede attenzione adesso`;
    }
  }
  $('#pageTitle').textContent =
    view === 'risorsa-detail' && globalThis.currentRisorsaDetail
      ? `Risorsa · ${globalThis.currentRisorsaDetail}`
      : t;
  $('#pageSub').textContent = s;
  if (view === 'todos') renderTodos();
  if (view === 'clienti') lazyRender('clienti', renderClienti);
  if (view === 'risorse') lazyRender('risorse', renderRisorse);
  if (view === 'risorsa-detail') renderRisorsaDetail();
  if (view === 'pm') renderPM();
  if (view === 'azioni') lazyRender('azioni', renderAzioni);
  if (view === 'scadenze') lazyRender('scadenze', renderScadenze);
  if (view === 'storico') lazyRender('storico', renderStorico);
  if (view === 'ruoli') lazyRender('ruoli', renderRuoli);
  if (view === 'sicurezza') renderSicurezza();
  if (view === 'dashboard') renderDashboard();
  if (view === 'controllo' && typeof renderControlloArea === 'function')
    lazyRender('controllo', () => renderControlloArea('controlloRoot'));
  if (view === 'impostazioni') lazyRender('impostazioni', renderProfilo);
}

function renderAll() {
  const u = getCurrentUser();
  if (u) {
    $('#userName').textContent = u.name;
    $('#userAvatar').textContent = initials(u.name);
    $('#userRoleLabel').textContent = roleLabel(u.role);
    const navLbl = document.getElementById('navDashLabel');
    if (navLbl) navLbl.textContent = isUtente() ? 'Le mie cose' : 'Riepilogo di oggi';
    applyRoleClass();
  }
  renderDashboard();
  if (typeof renderTodos === 'function') renderTodos();
  renderClienti();
  renderRisorse();
  renderPM();
  if (isAdmin()) {
    renderAzioni();
    renderScadenze();
    renderStorico();
    renderSicurezza();
  }
  renderProfilo();
}

// Navigazione sidebar
$$('.nav-item').forEach((a) => {
  a.addEventListener('click', (e) => {
    e.preventDefault();
    setView(a.dataset.view);
  });
});

// Link interni con data-view (es. dalla dashboard)
document.addEventListener('click', (e) => {
  const link = e.target.closest('[data-view]');
  if (link && !link.classList.contains('nav-item')) {
    e.preventDefault();
    setView(link.dataset.view);
  }
});

// Logout
document.getElementById('btnLogout').addEventListener('click', doLogout);

// Health check: render lazy quando il <details> viene aperto
document.getElementById('healthBlock')?.addEventListener('toggle', (e) => {
  if (e.target.open && typeof renderHealth === 'function') renderHealth();
});

// Click su nome/avatar in sidebar -> apre la propria anagrafica (Impostazioni)
document.getElementById('btnOpenProfile').addEventListener('click', () => setView('impostazioni'));

// Pulsante "Torna a Risorse" nel detail risorsa
document.getElementById('btnBackToRisorse')?.addEventListener('click', () => {
  globalThis.currentRisorsaDetail = null;
  setView('risorse');
});

Object.assign(globalThis, { setView, renderAll });
export {};
